export default __webpack_public_path__ + "static/media/ht.e7bad50b.svg";